(function() {
    function syncVariantToForm(container, form, idInput) {
        var checked = container.querySelector('input[type="radio"][data-variant-id]:checked');
        if (checked) {
            var vid = checked.value || checked.getAttribute('data-variant-id');
            if (vid) {
                idInput.value = vid;
                idInput.removeAttribute('disabled');
            }
        }
    }
    function setVariantByIndex(container, form, idInput, variants, index) {
        if (!variants || index < 0 || index >= variants.length) return;
        var target = variants[index];
        var vid = target.id;
        idInput.value = vid;
        idInput.removeAttribute('disabled');
        var radio = container.querySelector('input[type="radio"][data-variant-id="' + vid + '"], input[type="radio"][value="' + vid + '"]');
        if (radio && !radio.checked) {
            radio.checked = true;
            container.querySelectorAll('.rc-variant-selector__option').forEach(function(l) { l.classList.remove('is-selected'); });
            var label = radio.closest('.rc-variant-selector__option');
            if (label) label.classList.add('is-selected');
            radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
    function isSubscriptionSelected(rcRoot) {
        var checked = rcRoot.querySelector('input[name="purchaseOption"]:checked');
        if (checked) return checked.value === 'subscription';
        var sub = rcRoot.querySelector('.rc-purchase-option__subscription, .rc-purchase-option.rc-purchase-option__subscription');
        var onetime = rcRoot.querySelector('.rc-selection__onetime, .rc-purchase-option__onetime');
        if (onetime && onetime.hasAttribute('rc-selected')) return false;
        if (sub && sub.hasAttribute('rc-selected')) return true;
        return sub && sub.hasAttribute('rc-selected');
    }
    function syncVariantFromRechargeOption(container, form, idInput, rcRoot) {
        var dataEl = container.querySelector('.rc-variant-selector__data');
        if (!dataEl) return;
        try {
            var variants = JSON.parse(dataEl.textContent);
            if (!variants || variants.length < 2) return;
            var isSub = isSubscriptionSelected(rcRoot);
            setVariantByIndex(container, form, idInput, variants, isSub ? 0 : 1);
        } catch (e) {}
    }
    function attachRechargeSync(container, form, idInput) {
        var productId = container.getAttribute('data-product-id');
        function findRcRoot() {
            var root = document.querySelector('.rc-selection__root');
            if (root) return root;
            var rsw = document.querySelector('recharge-subscription-widget[product-id="' + productId + '"]');
            if (rsw) return rsw.querySelector('.rc-selection__root') || (rsw.shadowRoot && rsw.shadowRoot.querySelector('.rc-selection__root'));
            rsw = document.querySelector('recharge-subscription-widget');
            if (rsw) return rsw.querySelector('.rc-selection__root') || (rsw.shadowRoot && rsw.shadowRoot.querySelector('.rc-selection__root'));
            return null;
        }
        function runSync() {
            var rcRoot = findRcRoot();
            if (rcRoot) syncVariantFromRechargeOption(container, form, idInput, rcRoot);
        }
        runSync();
        setTimeout(runSync, 300);
        setTimeout(runSync, 800);
        document.addEventListener('change', function(e) {
            if (e.target && e.target.name === 'purchaseOption') {
                var root = e.target.closest('.rc-selection__root');
                if (root) {
                    var w = root.closest('recharge-subscription-widget');
                    var pid = w ? w.getAttribute('product-id') : null;
                    if (!pid || pid === productId) runSync();
                }
            }
        }, true);
        var observer = new MutationObserver(function() { runSync(); });
        var check = setInterval(function() {
            var rcRoot = findRcRoot();
            if (rcRoot) {
                clearInterval(check);
                observer.observe(rcRoot, { attributes: true, attributeFilter: ['rc-selected', 'rc-not-selected'], subtree: true });
                rcRoot.addEventListener('click', function(e) {
                    if (e.target.closest('.rc-purchase-option__subscription, .rc-purchase-option__onetime, .rc-selection__onetime')) runSync();
                });
            }
        }, 200);
        setTimeout(function() { clearInterval(check); }, 5000);
    }
    function initRcVariantSelector() {
        document.querySelectorAll('.rc-variant-selector').forEach(function(container) {
            if (container._rcInit) return;
            container._rcInit = true;
            var formId = container.getAttribute('data-form-id');
            var productId = container.getAttribute('data-product-id');
            var form = (formId && document.getElementById(formId)) || container.closest('form') || document.querySelector('form[data-type="add-to-cart-form"]');
            if (!form && productId) form = document.querySelector('form input[name="product-id"][value="' + productId + '"]')?.closest('form');
            if (!form) return;
            var idInput = form.querySelector('[name="id"], .product-variant-id');
            if (!idInput) return;
            syncVariantToForm(container, form, idInput);
            attachRechargeSync(container, form, idInput);
            form.addEventListener('submit', function() { syncVariantToForm(container, form, idInput); }, true);
            form.querySelectorAll('.product-form__submit, button[type="submit"]').forEach(function(btn) {
                btn.addEventListener('mousedown', function() { syncVariantToForm(container, form, idInput); }, true);
                btn.addEventListener('click', function() { syncVariantToForm(container, form, idInput); }, true);
            });
            container.querySelectorAll('input[type="radio"][data-variant-id]').forEach(function(radio) {
                radio.addEventListener('change', function() {
                    var vid = this.value || this.getAttribute('data-variant-id');
                    if (vid) {
                        idInput.value = vid;
                        idInput.removeAttribute('disabled');
                        container.querySelectorAll('.rc-variant-selector__option').forEach(function(l) { l.classList.remove('is-selected'); });
                        var label = this.closest('.rc-variant-selector__option');
                        if (label) label.classList.add('is-selected');
                    }
                });
            });
            container.querySelectorAll('.rc-variant-selector__option').forEach(function(label) {
                label.addEventListener('click', function(e) {
                    if (this.classList.contains('is-disabled')) return;
                    var radio = this.querySelector('input');
                    if (radio && !radio.checked) {
                        radio.checked = true;
                        radio.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            });
        });
    }
    function initCustomVariantRechargeSync() {
        document.querySelectorAll('variant-radios').forEach(function(variantRadios) {
            if (!variantRadios.querySelector('.custom-variant-label')) return;
            if (!variantRadios || variantRadios._rcCustomInit) return;
            variantRadios._rcCustomInit = true;
            var section = variantRadios.closest('.main-single-product, section, [id^="shopify-section"]');
            var form = section ? section.querySelector('form[data-type="add-to-cart-form"]') : null;
            if (!form) form = document.querySelector('form input[name="product-id"]')?.closest('form');
            if (!form) return;
            var idInput = form.querySelector('[name="id"], .product-variant-id');
            var productIdInput = form.querySelector('input[name="product-id"]');
            var sellingPlanInput = form.querySelector('[name="selling_plan"]');
            if (!idInput) return;
            function getVariantsForProduct(pid) {
                var el = variantRadios.querySelector('.product-variants-data[data-product-id="' + pid + '"], .custom-variant-product-variants[data-product-id="' + pid + '"]');
                if (!el) return null;
                try { return JSON.parse(el.textContent); } catch (e) { return null; }
            }
            function getActiveProductId() {
                var active = variantRadios.querySelector('.custom-variant-label.is-active');
                if (active) return active.getAttribute('data-product-id');
                var checked = variantRadios.querySelector('[data-two-option-mode] input[type="radio"]:checked');
                return checked ? (checked.getAttribute('data-product-id') || checked.value) : null;
            }
            function getActiveSellingPlanId() {
                var active = variantRadios.querySelector('.custom-variant-label.is-active');
                if (active) return active.getAttribute('data-selling-plan-id');
                var checked = variantRadios.querySelector('[data-two-option-mode] input[type="radio"]:checked');
                if (!checked) return null;
                var label = checked.nextElementSibling;
                if (!label || !label.classList.contains('custom-variant-label')) {
                    label = variantRadios.querySelector('label[for="' + checked.id + '"]');
                }
                return label ? label.getAttribute('data-selling-plan-id') : null;
            }
            function isSubscriptionSelected(rcRoot) {
                var checked = rcRoot.querySelector('input[name="purchaseOption"]:checked');
                if (checked) return checked.value === 'subscription';
                var sub = rcRoot.querySelector('.rc-purchase-option__subscription');
                var onetime = rcRoot.querySelector('.rc-selection__onetime, .rc-purchase-option__onetime');
                if (onetime && onetime.hasAttribute('rc-selected')) return false;
                return sub && sub.hasAttribute('rc-selected');
            }
            function findRcRoot() {
                var pid = getActiveProductId();
                var rsw = pid ? document.querySelector('recharge-subscription-widget[product-id="' + pid + '"]') : null;
                if (rsw) {
                    var root = rsw.querySelector('.rc-selection__root') || (rsw.shadowRoot && rsw.shadowRoot.querySelector('.rc-selection__root'));
                    if (root) return root;
                }
                var root = document.querySelector('.rc-selection__root');
                if (root) return root;
                rsw = document.querySelector('recharge-subscription-widget');
                if (rsw) return rsw.querySelector('.rc-selection__root') || (rsw.shadowRoot && rsw.shadowRoot.querySelector('.rc-selection__root'));
                return null;
            }
            function runSync() {
                var rcRoot = findRcRoot();
                if (!rcRoot) return;
                var pid = getActiveProductId();
                var variants = pid ? getVariantsForProduct(pid) : null;
                if (!variants || variants.length < 2) return;
                var isSub = isSubscriptionSelected(rcRoot);
                var target = variants[isSub ? 0 : 1];
                idInput.value = target.id;
                idInput.removeAttribute('disabled');
                if (productIdInput) productIdInput.value = pid;
                if (sellingPlanInput) {
                    if (isSub) {
                        sellingPlanInput.setAttribute('name', 'selling_plan');
                        sellingPlanInput.value = getActiveSellingPlanId() || sellingPlanInput.getAttribute('data-selling-plan-backup') || '';
                        sellingPlanInput.removeAttribute('disabled');
                    } else {
                        sellingPlanInput.removeAttribute('name');
                        sellingPlanInput.setAttribute('data-selling-plan-backup', sellingPlanInput.value);
                        sellingPlanInput.value = '';
                    }
                }
            }
            function syncActiveLabelFromRadios() {
                var checked = variantRadios.querySelector('[data-two-option-mode] input[type="radio"]:checked');
                if (!checked) return;
                var label = checked.nextElementSibling;
                if (!label || !label.classList.contains('custom-variant-label')) {
                    label = variantRadios.querySelector('label[for="' + checked.id + '"]');
                }
                if (!label) return;
                variantRadios.querySelectorAll('.custom-variant-label').forEach(function(lbl) {
                    lbl.classList.remove('is-active');
                });
                label.classList.add('is-active');
                if (productIdInput) productIdInput.value = label.getAttribute('data-product-id') || '';
                var planId = label.getAttribute('data-selling-plan-id') || '';
                if (sellingPlanInput && planId) {
                    sellingPlanInput.setAttribute('data-selling-plan-backup', planId);
                }
                var variants = getVariantsForProduct(label.getAttribute('data-product-id'));
                // Only set variant from label JSON when product is not a dual subscribe/onetime variant set
                if (!variants || variants.length < 2) {
                    var variantScript = label.querySelector('script[type="application/ld+json"]');
                    if (variantScript && idInput) {
                        try {
                            var v = JSON.parse(variantScript.textContent);
                            if (v && v.id) {
                                idInput.value = v.id;
                                idInput.removeAttribute('disabled');
                            }
                        } catch (e) {}
                    }
                    if (sellingPlanInput && planId) {
                        var rcRoot = findRcRoot();
                        var isSub = rcRoot ? isSubscriptionSelected(rcRoot) : true;
                        if (isSub) {
                            sellingPlanInput.setAttribute('name', 'selling_plan');
                            sellingPlanInput.value = planId;
                            sellingPlanInput.removeAttribute('disabled');
                        }
                    }
                }
            }
            syncActiveLabelFromRadios();
            runSync();
            setTimeout(function() { syncActiveLabelFromRadios(); runSync(); }, 300);
            setTimeout(function() { syncActiveLabelFromRadios(); runSync(); }, 800);
            form.addEventListener('submit', function() { syncActiveLabelFromRadios(); runSync(); }, true);
            form.querySelectorAll('.product-form__submit, button[type="submit"]').forEach(function(btn) {
                btn.addEventListener('mousedown', function() { syncActiveLabelFromRadios(); runSync(); }, true);
                btn.addEventListener('click', function() { syncActiveLabelFromRadios(); runSync(); }, true);
            });
            function reloadRechargeWidgetForProduct(pid, defaultVariantId) {
                var productContainer = form ? form.closest('.main-single-product__product, [data-product-id]') : null;
                if (!productContainer) productContainer = section ? section.querySelector('.main-single-product__product') : null;
                if (productContainer) productContainer.setAttribute('data-product-id', String(pid));
                var container = (section || form) ? (section || form).querySelector('.recharge-widget-container') : null;
                if (!container) container = productContainer ? productContainer.querySelector('.recharge-widget-container') : null;
                if (!container) container = document.querySelector('[data-product-id] .recharge-widget-container');
                if (container && typeof window.ReChargeWidget !== 'undefined') {
                    var h = container.offsetHeight;
                    container.style.height = (h || 80) + 'px';
                    container.innerHTML = '';
                    if (typeof window.ReChargeWidget.destroyWidgets === 'function') window.ReChargeWidget.destroyWidgets();
                    if (window.ReChargeWidget.api && typeof window.ReChargeWidget.api.fetchProduct === 'function') {
                        try { window.ReChargeWidget.api.fetchProduct(pid); } catch (e) {}
                    }
                    setTimeout(function() {
                        window.ReChargeWidget.createWidget({
                            productId: String(pid),
                            defaultVariantId: defaultVariantId ? String(defaultVariantId) : undefined,
                            injectionMethod: 'prepend',
                            injectionParent: container
                        });
                        setTimeout(function() { container.style.height = ''; }, 800);
                    }, 100);
                }
                var rswOuter = document.querySelector('recharge-subscription-widget');
                if (rswOuter) {
                    var newEl = document.createElement('recharge-subscription-widget');
                    newEl.setAttribute('product-id', String(pid));
                    if (defaultVariantId) newEl.setAttribute('default-variant-id', String(defaultVariantId));
                    rswOuter.replaceWith(newEl);
                }
            }
            variantRadios.querySelectorAll('[data-two-option-mode] input[type="radio"]').forEach(function(radio) {
                if (radio._rcChangeHooked) return;
                radio._rcChangeHooked = true;
                radio.addEventListener('change', function() {
                    if (!this.checked) return;
                    syncActiveLabelFromRadios();
                    var productContainer = form ? form.closest('.main-single-product__product, .single-product__product, .custom-products__product') : null;
                    var label = this.nextElementSibling;
                    if (!label || !label.classList.contains('custom-variant-label')) {
                        label = variantRadios.querySelector('label[for="' + this.id + '"]');
                    }
                    if (label) {
                        variantRadios.querySelectorAll('.custom-variant-label').forEach(function(l) { l.classList.remove('is-active'); });
                        label.classList.add('is-active');
                    }
                    var twoOptionFieldset = variantRadios.querySelector('[data-two-option-mode]');
                    if (twoOptionFieldset) twoOptionFieldset.classList.remove('is-missing-selection');
                    var reqMsg = variantRadios.querySelector('.product-form__variant-required-msg');
                    if (reqMsg) reqMsg.hidden = true;
                    if (productContainer) {
                        productContainer.querySelectorAll('.product-form__submit, [add-to-cart-button]').forEach(function(btn) {
                            btn.removeAttribute('disabled');
                            btn.removeAttribute('aria-disabled');
                            btn.classList.remove('is-disabled');
                        });
                        if (label && label.getAttribute('data-product-id')) {
                            productContainer.setAttribute('data-last-custom-product-id', label.getAttribute('data-product-id'));
                        }
                    }
                    var pid = this.getAttribute('data-product-id') || this.value;
                    var defaultVariantId = null;
                    if (label) {
                        var variantScript = label.querySelector('script[type="application/ld+json"]');
                        if (variantScript) {
                            try {
                                var v = JSON.parse(variantScript.textContent);
                                if (v && v.id) defaultVariantId = v.id;
                            } catch (e) {}
                        }
                    }
                    var variants = pid ? getVariantsForProduct(pid) : null;
                    if (pid && variants && variants.length >= 2 && typeof window.updateRcVariantSelectorForProduct === 'function') window.updateRcVariantSelectorForProduct(pid, variants);
                    if (pid) reloadRechargeWidgetForProduct(pid, defaultVariantId);
                    setTimeout(runSync, 150);
                });
            });
            variantRadios.querySelectorAll('.custom-variant-label').forEach(function(lbl) {
                if (lbl._rcClickHooked) return;
                lbl._rcClickHooked = true;
                lbl.addEventListener('click', function() {
                    var prev = lbl.previousElementSibling;
                    if (prev && prev.type === 'radio') {
                        if (!prev.checked) {
                            prev.checked = true;
                            prev.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        return;
                    }
                    var pid = lbl.getAttribute('data-product-id');
                    var variantScript = lbl.querySelector('script[type="application/ld+json"]');
                    var defaultVariantId = null;
                    if (variantScript) {
                        try {
                            var v = JSON.parse(variantScript.textContent);
                            if (v && v.id) defaultVariantId = v.id;
                        } catch (e) {}
                    }
                    variantRadios.querySelectorAll('.custom-variant-label').forEach(function(l) { l.classList.remove('is-active'); });
                    lbl.classList.add('is-active');
                    var variants = pid ? getVariantsForProduct(pid) : null;
                    if (pid && variants && variants.length >= 2 && typeof window.updateRcVariantSelectorForProduct === 'function') window.updateRcVariantSelectorForProduct(pid, variants);
                    if (pid) reloadRechargeWidgetForProduct(pid, defaultVariantId);
                    setTimeout(runSync, 150);
                });
            });
            document.addEventListener('change', function(e) {
                if (e.target && e.target.name === 'purchaseOption') runSync();
            }, true);
            var check = setInterval(function() {
                var rcRoot = findRcRoot();
                if (rcRoot) {
                    clearInterval(check);
                    new MutationObserver(runSync).observe(rcRoot, { attributes: true, attributeFilter: ['rc-selected', 'rc-not-selected'], subtree: true });
                    rcRoot.addEventListener('click', function(e) {
                        if (e.target.closest('.rc-purchase-option__subscription, .rc-purchase-option__onetime, .rc-selection__onetime')) runSync();
                    });
                }
            }, 200);
            setTimeout(function() { clearInterval(check); }, 5000);
        });
    }
    window.updateRcVariantSelectorForProduct = function(pid, variants) {
        if (!variants || variants.length < 2) return;
        var rcBlock = document.querySelector('.recharge-variant-selector-block');
        var rcContainer = rcBlock ? rcBlock.querySelector('.rc-variant-selector') : null;
        if (!rcContainer) return;
        var formId = rcContainer.getAttribute('data-form-id');
        rcContainer.setAttribute('data-product-id', String(pid));
        rcContainer._rcInit = false;
        var optionsHtml = variants.map(function(v, i) {
            var label = (v.option1 || v.title || '').replace(/"/g, '&quot;');
            var optClass = 'rc-variant-selector__option' + (i === 0 ? ' is-selected' : '') + (v.available === false ? ' is-disabled' : '');
            return '<label class="' + optClass + '" data-variant-id="' + v.id + '"><input type="radio" name="rc-variant-option-' + pid + '" value="' + v.id + '" form="' + (formId || '') + '" data-variant-id="' + v.id + '" data-option1="' + label + '"' + (i === 0 ? ' checked' : '') + (v.available === false ? ' disabled' : '') + '><span class="rc-variant-selector__label">' + (v.option1 || v.title) + '</span></label>';
        }).join('');
        var optionsEl = rcContainer.querySelector('.rc-variant-selector__options');
        var dataEl = rcContainer.querySelector('.rc-variant-selector__data');
        if (optionsEl) optionsEl.innerHTML = optionsHtml;
        if (dataEl) dataEl.textContent = JSON.stringify(variants);
        initRcVariantSelector();
    };
    function initAll() {
        initRcVariantSelector();
        initCustomVariantRechargeSync();
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
})();
